<template lang="html">

    <div>

        <section class="intro-simulador container">
            <h2>Simula tu ahorro!</h2>
            <p>Calcular lo que te vas a ahorrar contratando tu factura de la luz con Iner, ¡es muy fácil!</p>
            <p>Ten a mano tu factura de la luz para que podamos hacer mejor el cálculo de tu ahorro:</p>
            <img src="/static/img/cerdo.webp" class="cerdo">
        </section>

        <div class="contenedor-simulador container">

            <div class="contratacion-part">

                <!-- COMERCIALIZADORAS -->
                <article class="pregunta-el row-start">
                    <h4 class="-orange">Indícanos cuál es tu comercializadora actual*:</h4>
                    <div class="contenedor-selector -comercializadora row-start" :error="errors.has('comercializadora')">

                        <template v-for="comercializadora in serverData.comercializadoras">
                            <div class="selector" :fill="data.comercializadora == comercializadora.id" :error="errors.has('comercializadora')">
                                <input type="radio" :id="'comercializadora-'+comercializadora.id" name="comercializadora" :value="comercializadora.id" v-model="data.comercializadora"
                                    v-validate="'required'">
                                <label class="row-center" :for="'comercializadora-'+comercializadora.id" :title="comercializadora.alias">
                                    <span v-if="!!!comercializadora.nombre_logo" class="row-center">{{comercializadora.alias}}</span>
                                    <img v-if="!!comercializadora.nombre_logo" :src="comercializadora.nombre_logo" alt="">
                                </label>
                            </div>

                        </template>
                        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('comercializadora') }}</span>
                    </div>
                </article>
                <!-- -------------------- -->

                <!-- TIPO DE VIVIENDA -->
                <article class="pregunta-el">
                    <h4 class="-orange">Cuéntanos un poco más sobre donde vives. ¿Qué tipo de vivienda es?*</h4>
                    <div class="contenedor-selector row-start -tipovivienda" :error="errors.has('tipovivienda')">
                        <div class="selector" :fill="data.tipovivienda == 1" :error="errors.has('tipovivienda')">
                            <input type="radio" name="tipovivienda" value="1" v-model="data.tipovivienda" id="bloque" v-validate="'required'">
                            <label for="bloque">
                                <img src="/static/img/ciudad.svg" alt="Unifamiliar">
                                <img class="activa" src="/static/img/ciudad-activa.svg" alt="Unifamiliar">
                                <span>Bloque</span>
                            </label>
                        </div>
                        <div class="selector" :fill="data.tipovivienda == 0" :error="errors.has('tipovivienda')">
                            <input type="radio" id="unifamiliar" name="tipovivienda" value="0" v-model="data.tipovivienda">
                            <label for="unifamiliar">
                                <img src="/static/img/casa.svg" alt="Unifamiliar">
                                <img class="activa" src="/static/img/casa-activa.svg" alt="Unifamiliar">
                                <span>Unifamiliar</span>
                            </label>
                        </div>
                        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('tipovivienda') }}</span>
                    </div>
                </article>
                <!-- -------------------- -->


                <!-- TAMAÑO APROXIMADO -->
                <article class="pregunta-el -tamano" :error="errors.has('tamano')">
                    <h4 class="-orange">Tamaño aproximado:</h4>
                    <div class="contenedor-range">
                        <input type="range" :max="max" :min="min" v-model="data.tamano" name="tamano" step="1" @change="tamanoactive= true">
                        <figure class="relleno" :style="`width:${percent}%`"></figure>
                        <span class="min" :active="true">{{min}}</span>
                        <span class="max" :active="data.tamano >= max-4">+{{max}}</span>
                        <h5 class="result" :style="`left:${percent}%`" :down="down">{{data.tamano}}m2</h5>
                        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('tamano') }}</span>
                    </div>
                </article>
                <!-- -------------- -->


                <!-- PRIMERA VIVIENDA -->
                <article class="pregunta-el row-start" :error="errors.has('primeravivienda')">
                    <div class="contenedor-selector row-start">
                        <h4 class="-orange">¿Es tu primera vivienda?*:</h4>
                        <div class="selector" :fill="data.primeravivienda == 1" :error="errors.has('primeravivienda')">
                            <input type="radio" id="primeravivienda" name="primeravivienda" value="1" v-model="data.primeravivienda" v-validate="'required'">
                            <label for="primeravivienda">
                                <span>Si</span>
                            </label>
                        </div>
                        <div class="selector" :fill="data.primeravivienda == 0" :error="errors.has('primeravivienda')">
                            <input type="radio" name="primeravivienda" value="0" v-model="data.primeravivienda" id="noprimeravivienda" v-validate="'required'">
                            <label for="noprimeravivienda">
                                <span>No</span>
                            </label>
                        </div>
                        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('primeravivienda') }}</span>
                    </div>
                </article>
                <!-- ---------------------- -->



                <!-- AIRE ACONDICIONADO -->
                <article class="pregunta-el row-start" :error="errors.has('aireacondicionado')">
                    <div class="contenedor-selector row-start">
                        <h4 class="-orange">¿Tienes aire acondicionado?*:</h4>
                        <div class="selector" :fill="data.aireacondicionado == 1" :error="errors.has('aireacondicionado')">
                            <input type="radio" id="tieneaire" name="aireacondicionado" value="1" v-model="data.aireacondicionado" v-validate="'required'">
                            <label for="tieneaire">
                                <span>Si</span>
                            </label>
                        </div>
                        <div class="selector" :fill="data.aireacondicionado == 0" :error="errors.has('aireacondicionado')">
                            <input type="radio" name="aireacondicionado" value="0" v-model="data.aireacondicionado" id="notieneaire" v-validate="'required'">
                            <label for="notieneaire">
                                <span>No</span>
                            </label>
                        </div>
                        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('aireacondicionado') }}</span>
                    </div>
                </article>
                <!-- ---------------------- -->


                <!-- CALEFACCIÓN CENTRAL -->
                <article class="pregunta-el row-start">
                    <div class="contenedor-selector row-start" :error="errors.has('calefaccioncentral')">
                        <h4 class="-orange">¿Tienes calefacción central?*:</h4>
                        <div class="selector" :fill="data.calefaccioncentral == 1" :error="errors.has('calefaccioncentral')">
                            <input type="radio" id="calefaccioncentrar" name="calefaccioncentral" value="1" v-model="data.calefaccioncentral" v-validate="'required'">
                            <label for="calefaccioncentrar">
                                <span>Si</span>
                            </label>
                        </div>
                        <div class="selector" :fill="data.calefaccioncentral == 0" :error="errors.has('calefaccioncentral')">
                            <input type="radio" name="calefaccioncentral" value="0" v-model="data.calefaccioncentral" id="nocalefaccioncentral" v-validate="'required'">
                            <label for="nocalefaccioncentral">
                                <span>No</span>
                            </label>
                        </div>
                        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('calefaccioncentral') }}</span>
                    </div>
                </article>
                <!-- --------------- -->



                <!-- ELECTRODOMÉSTICOS -->
                <article class="pregunta-el">
                    <h4 class="-orange">Electrodomésticos: selecciona cuáles tienes:</h4>
                    <div class="contenedor-selector row-start -electrodomesticos">

                        <template v-for="electro in serverData.electrodomesticos">

                            <div class="selector" :fill="data.electrodomesticos.some(e=> e == electro.id)">
                                <input type="checkbox" :id="'electrodomestico-'+electro.id" name="electrodomestico" :value="electro.id" v-model="data.electrodomesticos">
                                <label :for="'electrodomestico-'+electro.id">
                                    <div class="contenedor-imagen row-center">
                                        <img :src="electro.icon" :alt="'electrodomestico-'+electro.id">
                                        <img class="activa" :src="electro['hover-icon']" :alt="'electrodomestico-'+electro.id">
                                    </div>
                                    <span>{{electro.name}}</span>
                                </label>
                            </div>

                        </template>

                        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('electrodomestico') }}</span>
                    </div>
                </article>
                <!-- -------------------- -->


                <!-- HORARIOS -->
                <article class="pregunta-el">
                    <h4 class="-orange">¿En qué horas hay gente despierta en casa?</h4>
                    <div class="contenedor-horas">
                        <horas-selector :error="errors.has('horas-semana')" v-model="data.entresemana" :label="'Entre semana'" v-validate="'required'" name="horas-semana"></horas-selector>
                        <span class="error -horas">{{ errors.first('horas-semana') }}</span>
                    </div>
                    <div class="contenedor-horas">
                        <horas-selector :error="errors.has('horas-findesemana')" v-model="data.findesemana" :label="'Fin de semana'" v-validate="'required'" name="horas-findesemana"></horas-selector>
                        <span class="error -horas">{{ errors.first('horas-findesemana') }}</span>
                    </div>
                </article>
                <!-- --------------- -->



                <!-- CUPS -->
                <article class="pregunta-el row-start -cups">
                    <h4 class="-orange">Introduce el código CUPS de tu actual factura de la luz*:</h4>
                    <p>
                        En tu factura de la luz encontrarás tu CUPS
                        <span class="show-info-cups" @click="showInfoCups= !showInfoCups">?</span>
                    </p>
                    <div class="contenedor-input" :fill="!!data.cups" :error="(errors.has('cups') || errorcups != -1)" @click="focus('cups')">
                        <input type="text" class="input-text" v-model="data.cups" :fill="!!data.cups" v-validate="'required|min:20|max:24'" @keyup.enter="checkCUPS" @keyup="quitarEspacios" name="cups"
                            />
                        <label for="">CUPS</label>
                        <span class="contenedor-spin row-center">
                            <half-circle-spinner v-if="loadingCups" :animation-duration="1000" :size="20" color="#F6A910" />
                            </span>
                            <img src="/static/img/tick-naranja.svg" alt="CUPS OK" class="cups-ok" :show="!!data.cups_object && errorcups == -1">
                            <span class="error" v-if="errorcups == -1">{{ errors.first('cups') }}</span>
                        </div>
                        <a @click="checkCUPS" v-if="data.cups.length >= 20" class="btn -degree" v-show="errorcups != -1">Validar</a>
                        <info-cups-popup @close="showInfoCups= false" v-if="showInfoCups"></info-cups-popup>
                        <mensajes-errores-cups :counts="0" v-if="errorcups> -1" :iderror="errorcups"></mensajes-errores-cups>
                    </article>
                    <!-- ----------------------- -->




                    <!-- CALCULO EXACTO -->
                    <article class="pregunta-el row-start">


                        <h4 class="-orange">¿Quieres un cálculo exacto?*</h4>

                        <div class="contenedor-selector row-start -calculo-exacto" :error="errors.has('calculoexacto')">
                            <div class="selector" :fill="data.calculoexacto == 1" :error="errors.has('calculoexacto')">
                                <input type="radio" id="calculoexacto" name="calculoexacto" value="1" v-model="data.calculoexacto" v-validate="'required'">
                                <label for="calculoexacto">
                                    <span>Si</span>
                                </label>
                            </div>
                            <div class="selector" :fill="data.calculoexacto == 0" :error="errors.has('calculoexacto')">
                                <input type="radio" name="calculoexacto" value="0" v-model="data.calculoexacto" id="nocalculoexacto" v-validate="'required'">
                                <label for="nocalculoexacto">
                                    <span>No</span>
                                </label>
                            </div>
                            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('calculoexacto') }}</span>
                        </div>


                        <template v-if="data.calculoexacto == 1">

                            <div class="pregunta-el child">
                                <h4 class="-orange">¿Qué tipo de tarifa tienes?</h4>
                                <div class="contenedor-selector row-start" :error="errors.has('tipotarifa')">
                                    <div class="selector" :fill="data.tipotarifa == 1">
                                        <input type="radio" id="condiscriminacion" name="tipotarifa" value="1" v-model="data.tipotarifa">
                                        <label for="condiscriminacion">
                                            <span>Con discriminación horaria</span>
                                        </label>
                                    </div>
                                    <div class="selector" :fill="data.tipotarifa == 0">
                                        <input type="radio" name="tipotarifa" value="0" v-model="data.tipotarifa" id="sindiscriminacion">
                                        <label for="sindiscriminacion">
                                            <span>Sin discriminación horaria</span>
                                        </label>
                                    </div>
                                    <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('tipotarifa') }}</span>
                                </div>
                            </div>

                            <div class="pregunta-el child row-start" v-if="data.tipotarifa != undefined">

                                <h4 class="-orange">Introduce los costes que tienes ahora mismo:</h4>



                                <div class="contenedor-input -middle" :fill="!!data.preciopotencia" :error="errors.has('preciopotencia')" @click="focus('preciopotencia')">
                                    <input type="number" class="input-text"
                                        v-model="data.preciopotencia"
                                        :fill="!!data.preciopotencia"
                                        v-validate="'required'"
                                        name="preciopotencia" />
                                    <label for="">Precio Potencia (€/Kwdía)</label>
                                    <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('preciopotencia') }}</span>
                                </div>

                                <div class="contenedor-input -middle" :fill="!!data.preciocuotafija" :error="errors.has('preciocuotafija')" @click="focus('preciocuotafija')">
                                    <input type="number" class="input-text"
                                        v-model="data.preciocuotafija"
                                        :fill="!!data.preciocuotafija"
                                        name="preciocuotafija" />
                                    <label for="">Cuota fija mensual</label>
                                    <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('preciocuotafija') }}</span>
                                </div>

                                <template v-if="data.tipotarifa == '0'">

                                    <div class="contenedor-input -middle" :fill="!!data.precioenergia" :error="errors.has('precioenergia')" @click="focus('precioenergia')">
                                        <input type="number" class="input-text"
                                            v-model="data.precioenergia"
                                            :fill="!!data.precioenergia"
                                            v-validate="'required'"
                                            name="precioenergia" />
                                        <label for="">Precio Energía (€/Kwh)</label>
                                        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('precioenergia') }}</span>
                                    </div>

                                </template>

                                <template v-if="data.tipotarifa == '1'">

                                    <div class="contenedor-input -middle" :fill="!!data.preciovalle" :error="errors.has('preciovalle')" @click="focus('preciovalle')">
                                        <input type="number" class="input-text"
                                            v-model="data.preciovalle"
                                            :fill="!!data.preciovalle"
                                            v-validate="'required'"
                                            name="preciovalle" />
                                        <label for="">Precio Valle (€/Kwh)</label>
                                        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('preciovalle') }}</span>
                                    </div>

                                    <div class="contenedor-input -middle" :fill="!!data.preciopunta" :error="errors.has('preciopunta')" @click="focus('preciopunta')">
                                        <input type="number" class="input-text"
                                            v-model="data.preciopunta"
                                            :fill="!!data.preciopunta"
                                            v-validate="'required'"
                                            name="preciopunta" />
                                        <label for="">Precio Punta (€/Kwh)</label>
                                        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('preciopunta') }}</span>
                                    </div>

                                </template>



                            </div>

                        </template>


                        <template v-if="data.calculoexacto == 0">

                            <!-- PAGO -->
                            <article class="pregunta-el child">
                                <h4 class="-orange">Dinos de forma aproximada cuánto pagas de media al mes de luz:</h4>
                                <div class="contenedor-input" :fill="!!data.pago" :error="errors.has('pago')" @click="focus('pago')">
                                    <input type="text" class="input-text"
                                        v-model="data.pago"
                                        :fill="!!data.pago"
                                        v-validate="'required'"
                                        name="pago" />
                                    <label for="">Indica la cantidad (€)</label>
                                    <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('pago') }}</span>
                                </div>
                            </article>
                            <!-- ------- -->

                        </template>

                    </article>
                    <!-- FIN CALCULO EXACTO -->


                    <!-- TIENES GAS -->
                    <article class="pregunta-el row-start" v-if="serverData">
                        <h4 class="-orange">¿Tienes Gas para alguno de estos usos?:</h4>
                        <div class="contenedor-selector -gas row-start">
                            <template v-for="uso in serverData.gas">
                                <div class="selector" :fill="data.usosgas.some(e=> e == uso.id)">
                                    <input type="checkbox" :id="'gas-'+uso.id" name="usosgas" :value="uso.id" v-model="data.usosgas">
                                    <label :for="'gas-'+uso.id">
                                        <span>{{uso.name}}</span>
                                    </label>
                                </div>
                            </template>
                            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('tipotarifa') }}</span>
                        </div>
                    </article>
                    <!-- ------------------ -->

                    <div class="contenedor-boton row-center">

                        <p class="animated shake errores" v-if="errors.items.length> 1 || errorcups != -1">Por favor, revisa los campos que faltan por rellenar y que tu CUPS cumpla con los requisitos
                            para la simulación</p>

                        <a @click="validate" class="btn -degree" :loading="loadingsend">Calcular</a>

                        <mensajes-errores-cups class="error-envio" :counts="0" :type="'electric'" v-if="errorenvio != -1" :iderror="errorenvio"></mensajes-errores-cups>

                    </div>




                </div>


            </div>

        </div>

    </template>

    <script lang="js">
    import horas from '@/components/view-parts/simulador/horas-selector';
    import {
        mapActions
    } from 'vuex';

    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);

    import {
        Validator
    } from "vee-validate"


    import infoCupsPopup from '@/components/parts/cups-popup-info';

    import mensajesErroresCups from '@/components/parts/mensaje-error-cups';

    import router from '@/router';

    import {
        HalfCircleSpinner
    } from 'epic-spinners';

  


    export default {
        name: 'formulario-simulador',
        mounted() {
            this.getData();
        },
        data() {
            return {
                serverData: '',
                clicked: false,
                min: 30,
                max: 200,
                errorcups: -1,
                tamanoactive: false,
                loadingCups: false,
                loadingsend: false,
                showInfoCups: false,
                errorenvio : -1,
                data: {
                    cups: '',
                    cups_object: '',
                    comercializadora: '',
                    pago: '',
                    calculoexacto: undefined,
                    preciopotencia: '',
                    precioenergia: '',
                    preciocuotafija: '',
                    tipotarifa: undefined,
                    preciovalle: '',
                    preciopunta: '',
                    entresemana: [],
                    findesemana: [],
                    tipovivienda: undefined,
                    tamano: 85,
                    primeravivienda: undefined,
                    aireacondicionado: undefined,
                    calefaccioncentral: undefined,
                    electrodomesticos: [],
                    usosgas: []
                }
            }
        },
        computed: {
            percent() {
                return ((this.data.tamano - this.min) * 100) / (this.max - this.min);
            },
            down() {
                return (this.data.tamano < this.min + 20 || this.data.tamano > this.max - 20);
            }
        },
        components: {
            'horas-selector': horas,
            HalfCircleSpinner,
            'info-cups-popup': infoCupsPopup,
            mensajesErroresCups,
        },
        methods: {
            ...mapActions(['requestDataSimulador', 'checkCUPSsimulador', 'sendDataSimulacion', 'sendSetCups']),
            getData() {
                this.requestDataSimulador().then(r => {
                    this.serverData = r;
                });
            },
            checkCUPS() {

                //TARIFA 0 DH
                //TARIFA 1 DHA

                this.loadingCups = true;
                this.checkCUPSsimulador(this.data.cups).then(r => {
                    this.errorcups = -1;
                    this.data.cups_object = r;
                    this.data.tipotarifa = (r.codigoTarifaATREnVigor == 4) ? 1 : 0;
                    this.loadingCups = false;
                    router.replace({name : 'simulador', params:{ paso : 'cups'}})
                    this.sendSetCups(this.data.cups);
                }).catch(e => {
                    this.errorcups = e;
                    this.loadingCups = false;
                });
            },
            validate() {
                this.clicked = true;
                this.$validator.validateAll().then(canSend => {
                    if (canSend && this.errorcups == -1) {
                        this.loadingsend = true;
                        (!!!this.tamanoactive) ? this.data.tamano = 0: '';
                        (!!!this.data.preciocuotafija) ? this.data.preciocuotafija = 0: '';
                        this.sendDataSimulacion(this.data)
                            .then(result => {
                                this.setsendend(result);
                            }).catch(error => {
                                this.loadingsend = false;
                                this.errorenvio = error;
                            });
                    }else{
                        setTimeout(e => {
                            console.log($("*[error=true]").length );
                            if($("*[error=true]").length > 0){
                                let to = $("*[error=true]").eq(0).offset().top - 180;
                                $("html, body").animate({scrollTop: to},500);
                            }
                        },100);
                    }
                });
            },
            setsendend(result) {
                this.$emit('sendend', result);
                this.loadingsend = false;
                this.errorenvio = -1;
                router.replace({name : 'simulador', params:{ paso : 'datos-personales'}})
            },
            focus(where) {
                document.querySelector(`*[name=${where}]`).focus();
                document.querySelector(`*[name=${where}]`).click();
            },
            quitarEspacios() {
                this.data.cups = this.data.cups.replace(/ /g, "");
                this.data.cups = this.data.cups.replace(/\t/g, '');
                this.errorcups = -2;
            },
        },
        watch: {
            'data.tipotarifa': function() {
                // this.$validator.clean();
                this.errors.clear()
            }
        }
    }
</script>

    <style scoped lang="scss">
    @import '@/assets/css/colors.scss';
    .contratacion-part {
        max-width: 100%;
    }
    
    .intro-simulador {
        .cerdo {
            max-width: 200px;
            top: -10px;
            transform: translateX(-50px);
        }
    }
    
    .contenedor-boton .errores {
        margin-bottom: 20px;
        color: $rojo;
    }
    
    .cups-ok {
        position: absolute;
        max-width: 40px;
        right: 10px;
        top: 10px;
        opacity: 0;
        transition: .5s;
        &[show=true] {
            opacity: 1;
        }
    }
    
    .contenedor-spin {
        position: absolute;
        right: 10px;
        top: 10px;
        height: 40px;
        width: 40px;
        line-height: 40px;
        text-align: center;
    }
    
    .-cups p {
        width: 100%;
        text-align: left;
        display: inline-block;
        font-weight: 800;
        margin-bottom: 10px;
        font-size: 18px;
        padding-right: 10px;
    }
    
    .show-info-cups {
        width: 20px;
        height: 20px;
        display: inline-block;
        background: $orange;
        text-align: center;
        line-height: 20px;
        font-size: 12px;
        color: white;
        border-radius: 50%;
        cursor: pointer;
        margin-left: 10px;
        transform: translateY(-10px);
    }
    
    .contenedor-error-cups {
        margin-top: 20px;
        .btn {
            margin-left: 0;
        }
    }
    
    .contenedor-horas {
        position: relative;
        display: inline-block;
        width: 100%;
        .error.-horas {
            color: $rojo;
            font-size: 12px;
            position: absolute;
            left: 0;
            bottom: 10px;
        }
    }
    
    @media screen and (max-width: 400px) {
        .-cups p {
            font-size: 16px;
        }
        .show-info-cups {
            margin-left: 0;
        }
        .contenedor-simulador .pregunta-el .contenedor-error-cups {
            margin-top: 10px;
            h4 {
                margin-bottom: 0;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/view-parts/simulador/formulario-simulador.vue